import api from "@/services/apiService"

class NewsService {

  getNews() {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_API_MAIN + 'news', {silent: true})
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        reject(error)
      })
    })
  }

}

export default new NewsService()
